<template>
  <p class="small" v-html="text" />
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
});
</script>
